import { FC, useEffect } from "react";
import "./CancelConfirmation.scss";
import MainNavbar from "../../../components/MainNavbar/MainNavbar";
import { useLocation, useNavigate } from "react-router-dom";

const CancelConfirmation: FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const refundAmount: number | null = state?.refund_amount ?? null;

  const formattedAmount = refundAmount
    ? refundAmount.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    : null;

  useEffect(() => {
    if (!state) {
      navigate("/profile/general", { replace: true });
    }
  }, []);

  return (
    <>
      <MainNavbar />
      <div className="CancelConfirmation" data-testid="CancelConfirmation">
        <div className="cancel-confirmation-card">
          <h2 className="cancel-confirmation-title">Sua assinatura foi cancelada!</h2>
          <p className="cancel-confirmation-subtitle">
            {formattedAmount
              ? <>O reembolso será realizado de acordo com<br/>método de pagamento utilizado.</>
              : <>Você ainda pode utilizar todos os benefícios<br/>até o fim do período já pago.</>}
          </p>
        </div>
      </div>
    </>
  );
};

export default CancelConfirmation;
